import React from 'react';
import Title from '../Title';
import './Chatbot.css';

export default function Chatbot() {
    return (
        <div>
            <div className="chatbot-background">
                <Title title="chatbot" color="skyblue"/>
            </div>
        </div>
    )
}
